import { Stack, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { useState } from 'react'
import { BsFillPersonPlusFill } from "react-icons/bs"
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'
import TableStaff from '../../views/member/TableStaff'
import Staff from './Staff'

const StaffList = () => {
  const [selected, setSelected] = useState([])
  const [reload, setReload] = useState(0)
  const [show, setShow] = useState(false)

  return (
    <Page title="Staff">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  Staff 관리
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              Staff 리스트를 보여줍니다
            </Typography>
          }
        />
        <BoxWrapper>
          <Button variant="contained" startIcon={<BsFillPersonPlusFill />} onClick={()=>{ setShow(true) }} >Staff 등록</Button>          
        </BoxWrapper>
        <Grid item xs={12}>
          <TableStaff reload={reload} setReload={setReload} selected={selected} setSelected={setSelected} />
        </Grid>
      </Grid>
      <Staff show={show} setShow={setShow} setReload={setReload} />
    </Page>
  )
}

export default StaffList